import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
//import "./printOut/assets/billModal.css";
import SidebarEtd from '../../../shared/components/SidebarEtd';
import HeaderEtd from '../../../shared/components/HeaderEtd';
import { FaSearch, FaTrashAlt } from "react-icons/fa";
import { getLoginInfo } from '../../../shared/utils/storage';
import { createNotification } from '../../../shared/components/Popup';
import AppManagementReusComponent from '../../../shared/hooks/useApplicationManagement';
import Lindo from '../../../app/guards/RouteGuard';
import { searchApplicationFormValidator } from '../../../shared/validators/FormValidator';
const UnlockApplicationComponent = () => {
  const { isLoading, handleApplicationManagement } =
    AppManagementReusComponent();
  const [loading, setLoading] = useState(false);
  const [isTableData, setIsTableData] = useState(false);
  const [applicationId, setApplicationId] = useState();
  const [searchErrors, setSearchErrors] = useState({});
  const { mgambo } = Lindo();
  const navigate = useNavigate();
  const [appInfo, setAppInfo] = useState();
  const clearData = () => {
    setApplicationId("");
    setIsTableData(false);
  };

  useEffect(() => {
    mgambo("FunguaOmbi");
  }, []);
  const searchApplication = async () => {
    const validationErrors = searchApplicationFormValidator(applicationId);
    if (Object.keys(validationErrors).length > 0) {
      setSearchErrors(validationErrors);
      return;
    }
    setSearchErrors({});
    setLoading(true);
    const payload = {
      ApplicationId: applicationId,
      UserName: getLoginInfo()?.user?.Username,
      Station: getLoginInfo()?.user?.StationID,
      FirstName: "",
      ReportType: "Management",
      Surname: "",
    };

    const result = await handleApplicationManagement(payload, "reports");
    if (result?.code == 1) {
      setLoading(false);
      setAppInfo(result.data[0]);
      setIsTableData(true);
    } else {
      setLoading(false);
      const info = { type: "error", message: result?.message };
      result?.data && createNotification(info)();
    }
  };
  const unlockApplication = async (applicationID) => {
    setLoading(true);
    const payload = {
      ApplicationId: applicationID,
      OperationType: "ADMINUNLOCK",
      UserName: getLoginInfo()?.user?.Username,
      Station: getLoginInfo()?.user?.StationID,
    };

    const result = await handleApplicationManagement(
      payload,
      "pull_management",
    );
    if (result.code == 1) {
      setLoading(false);
      const info = { type: "success", message: result.message };
      createNotification(info)();
    } else {
      setLoading(false);
      const info = { type: "error", message: result.message };
      createNotification(info)();
    }
  };

  const styles = {
    h4: {
      color: "#850505",
      textTransform: "uppercase",
    },
  };
  return (
    <>
      <HeaderEtd />
      <body className="">
        <div className="wrapper">
          <SidebarEtd />
          <div className="main-panel">
            <div className="content4">
              <br />
              <div className="card-body">
                <h3 style={{ color: "#c2c2c2" }}>
                  <i>Unlock Application</i>
                </h3>
              </div>
              <div className="row2">
                <div className="col-md-12">
                  <div className="card2">
                    <div className="card-body4">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row">
                            <div
                              className="column"
                              style={{ backgroundColor: "#aaa;" }}
                            >
                              <p>
                                <table>
                                  <tr>
                                    <td colSpan={5}>
                                      <label
                                        className="control-label"
                                        for="FirstName"
                                      >
                                        <b style={{ color: "green" }}>
                                          Search Application:
                                        </b>
                                      </label>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <input
                                        type="text"
                                        id="ApplicationID"
                                        className="form-control"
                                        name="ApplicationID"
                                        aria-required="true"
                                        placeholder="Application No."
                                        style={{
                                          color: "#850505",
                                          fontSize: "1rem",
                                          width: "320px",
                                        }}
                                        value={applicationId}
                                        onChange={(e) =>
                                          setApplicationId(e.target.value)
                                        }
                                      />
                                      {searchErrors.applicationId && (
                                        <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
                                          {searchErrors.applicationId}
                                        </div>
                                      )}
                                    </td>
                                    <td>&nbsp;&nbsp;&nbsp;</td>
                                    <td>
                                      <button
                                        type="submit"
                                        className="btn btn-primary"
                                        onClick={() => searchApplication()}
                                        name="submit"
                                        style={{ height: "35px" }}
                                      >
                                        {loading ? (
                                          "Wait.."
                                        ) : (
                                          <b>
                                            <FaSearch
                                              style={{ fontSize: "15px" }}
                                            />
                                          </b>
                                        )}
                                      </button>
                                    </td>
                                    <td>&nbsp;&nbsp;&nbsp;</td>
                                    <td>
                                      <button
                                        type="clear"
                                        className="btn btn-warning"
                                        name="clear"
                                        onClick={clearData}
                                        style={{ height: "35px" }}
                                      >
                                        <b>
                                          <FaTrashAlt
                                            style={{ fontSize: "15px" }}
                                          />
                                        </b>
                                      </button>
                                    </td>
                                    <td></td>
                                  </tr>
                                </table>
                              </p>
                            </div>
                            <div>&nbsp;&nbsp;&nbsp;</div>
                            <div
                              className="column"
                              style={{ backgroundColor: "#bbb;" }}
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {isTableData && (
                    <div className="card2">
                      <div className="card-body">
                        <div className="container">
                          <table
                            id="myTable"
                            className="table table-striped table-bordered"
                            style={{ width: "100%" }}
                          >
                            <thead>
                              <tr>
                                <th style={{ width: "10%" }}>
                                  <b>ApplicationID</b>
                                </th>
                                <th style={{ width: "27%" }}>
                                  <b>Full Name</b>
                                </th>
                                <th style={{ width: "13%" }}>
                                  <b>Stage</b>
                                </th>
                                <th style={{ width: "13%" }}>
                                  <b>Locked by</b>
                                </th>
                                <th style={{ width: "18%" }}>
                                  <b>Action</b>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <h4 style={styles.h4}>
                                    {appInfo?.ApplicationID}
                                  </h4>
                                </td>
                                <td>
                                  <h4 style={styles.h4}>{appInfo?.FullName}</h4>
                                </td>
                                <td>
                                  <h4 style={styles.h4}>
                                    {appInfo?.DocStageName}
                                  </h4>
                                </td>{" "}
                                <td>
                                  <h4 style={styles.h4}>
                                    {appInfo?.IsLockedBy}
                                  </h4>
                                </td>
                                <td>
                                  <button
                                    type="submit"
                                    className="btn btn-primary btn-sm"
                                    name="ViewPass"
                                    value="0002033"
                                    onClick={() =>
                                      unlockApplication(appInfo?.ApplicationID)
                                    }
                                  >
                                    {loading ? "Wait.." : "Unlock"}
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </>
  );
};

export default UnlockApplicationComponent;
